/** De dónde salió el DATO, que es otra pregunta que cómo se calculó (eso es el nivel).
 *
 *  Tres estados y no un booleano, desde que Essity manda material real. El que importa no es
 *  `real` —una tarjeta entera de dato real es honesta— sino **`mixto`**: una especificación real
 *  cruzada con una medición sintética da un «% fuera de especificación» que se lee exactamente
 *  igual que uno de verdad y no lo es. Por eso es el único de los tres en rojo.
 *
 *  Cada uno lleva signo además de color: quien no distinga el ámbar del rojo se quedaría sin el
 *  aviso, y este aviso es el que decide si una cifra se puede sacar de la pantalla.
 */
import type { Idioma, Origen } from "../lib/tipos";
import { t } from "../lib/i18n";

const SIGNO: Record<Origen, string> = { sintetico: "◇", real: "🔒", mixto: "⚠" };

export function ChipProcedencia({ origen, idioma }: { origen: Origen; idioma: Idioma }) {
  const txt = t(idioma);
  return (
    <span className={`chip procedencia-${origen}`} title={txt.procedenciaLarga[origen]}>
      <span className="signo-aviso" aria-hidden="true">{SIGNO[origen]}</span>
      {txt.procedencia[origen]}
    </span>
  );
}
